import { Form, Row, Col, Button, message, Select, Input } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getDataInfo, stepperMoving } from '../../stores/actions';
import { patchApi } from '../../apis';
import helper from '../../utils/helper';
import { OutPutResult, UserInfoUI } from '@operations/shared';
import { errorMessage } from '../../utils/commonStringsConsts';
import moment from 'moment';

const { Option } = Select;

interface Props {
    info?: {
        name: string,
        companyName: string,
        phone: string,
        email: string,

        consent: [],
        nationalId: any,
        hrLetter: [],
        accountCreatedAt: string,
        bankAccountHolderName: string,
        bankAccountNumber: string,
        bankName: string,

        userStatus: string,
        userStatusType: string,

        maxAdvancePercentAllowedPerCompany: number,
        maxBalance: number,
        maxShoppingBalnce: number,

        wallet: number,
        staff_id: string,
        companyMaxInstallmentCount: number,
        nationalIDNumber: string,
        netSalary: any,

        suspensionStatus: {
            comment: string,
            date: string,
            isSuspended: number,
            reason: string
        }
    }
    patchApi?: any,
    stepperMoving?: any,
    fromViewUserAction: boolean,
    getDataInfo: any,
}
class UserSuspending extends Component<Props> {
    state = {
        dataSpin: false,
        reasons: [],
        loadingReasons: false,
        errorMode: false,
        selectedReason: null
    }

    componentDidMount(): void {
        this.getReasons()
    }

    getReasons = async () => {
        try {
            this.setState({ loadingReasons: true })
            const res: any = await helper.getSuspensionReasons()
            if (res.data.status === 200) {
                this.setState({ reasons: res.data.data, loadingReasons: false })
            }
            else {
                this.setState({ loadingReasons: false, errorMode: true })
            }
        }
        catch (error) {
            this.setState({ loadingReasons: false, errorMode: true })
            console.log("🚀 ~ file: userSuspending.tsx:53 ~ UserSuspending ~ getReasons= ~ error:", error)
        }
    }

    suspendingAction = async (values: { reasonID: number | string, comment: string }) => {
        this.setState({ dataSpin: true })
        const data: any = {
            phone: this.props.info?.phone,
            reasonID: values?.reasonID,
            comment: values?.comment
        }
        const endingCall = await this.props.patchApi('/users/suspendUser', data);
        try {
            const res = endingCall.payload;
            if (res.status === 200) {
                message.success(res.message);
                if (this.props?.fromViewUserAction) {
                    const reason: any = this.state.reasons?.find((reason: { id: number }) => reason.id === data?.reasonID)
                    this.props.getDataInfo({
                        ...this.props.info,
                        suspensionStatus: {
                            ...this.props.info?.suspensionStatus,
                            comment: data?.comment,
                            date: moment(),
                            isSuspended: 1,
                            reason: reason?.name,
                        }
                    });
                    this.props.stepperMoving(1);
                } else {
                    helper.resetAccountTableInStepper();
                    this.props.stepperMoving(0);
                }
            }
            else {
                console.log(res.message);
                message.error(res.message)
            }
            this.setState({ dataSpin: false });
        } catch (error) {
            this.setState({ dataSpin: false })
            console.log(error);
            message.error('Something went wrong, please try again');

        }
    }
    render() {
        const { dataSpin, reasons, errorMode, loadingReasons, selectedReason } = this.state;
        const suspensionStatusInfo = [
            {
                key: 'Suspension Reason',
                value: <Form.Item
                    name="reasonID"
                    rules={[{ required: true, message: 'Required' }]}

                >
                    <Select
                        loading={loadingReasons}
                        placeholder="Select a reason"
                        onChange={(value) => this.setState({ selectedReason: value })}
                    >
                        {Array.isArray(reasons) && reasons.map((reason: any, key: number) => {
                            return <Option value={reason.id} key={key}>{reason.name}</Option>
                        })}
                    </Select>
                </Form.Item>
            },
            {
                key: 'Comment',
                value: <Form.Item
                    name="comment"
                    rules={[{ required: selectedReason === 2, message: 'Required' }]}
                >
                    <Input.TextArea placeholder="Enter a comment" style={{ height: "32px" }} />
                </Form.Item>
            }
        ]
        return (
            errorMode ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage}
                btnTitle={'Refresh the page'} btnClick={helper.refreshPage} /> :
                <>
                    <Form name="nest-messages" onFinish={this.suspendingAction}>
                        <Row>
                            <Col span={24}>
                                <UserInfoUI userData={suspensionStatusInfo} activeKey={1} header={'Suspension Status'} nonEditable={true} collapsible={"disabled"} />
                            </Col>
                            <Col className='colOfAssign' span='24   ' style={{ display: "flex", justifyContent: "end" }}>
                                <Form.Item>
                                    <Button style={{ margin: '22px 0 0 0 ', width: '120px', background: '#7CC58F', borderColor: '#7CC58F' }} className='suspendUserBtn' shape="round" type="primary" htmlType="submit" loading={dataSpin} >
                                        Suspend
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </>
        )
    }
}
const mapStateToProps = (state: any) => ({
    info: state.actionsReducer.info,
    fromViewUserAction: state.actionsReducer.isViewUserAction
})
export default connect(mapStateToProps, { patchApi, stepperMoving, getDataInfo })(UserSuspending)


